import {useEffect, useState} from 'react';
import {useSelector, useStore} from 'react-redux';
import {smoothScroll} from '~/common/scroll';
import {TimeSince} from '~/ViewInvitation/common/TimeSince';
import {deletePost} from '~/ViewInvitation/reducers/apiActions';
import {selectPost} from '~/ViewInvitation/reducers/posts';
import {AttendeeCopy} from '~/ViewInvitation/routes/Guests/AttendeeCopy';
import {CommentButton} from '~/ViewInvitation/routes/Guests/CommentButton';
import {LastViewedCopy} from '~/ViewInvitation/routes/Guests/LastViewedCopy';
import {LikeButton} from '~/ViewInvitation/routes/Guests/LikeButton';
import {Typography} from '~library/atoms/Typography';

export const Guest = (props) => {
  const {
    guest,
    label,
    handleCommentOpen,
    handleSetEditing,
    setCommentPostId,
    isParentPost,
    isReply,
  } = props;
  const store = useStore();

  const [isEditingThisComment, setIsEditingThisComment] = useState(false);
  const thisPostId = guest.post_id;

  const post = useSelector(selectPost(thisPostId));

  const currentUserId = useSelector((s) => s.user.userId);
  const {hasRsvpd} = useSelector((store) => store.rsvp);
  const isHost = useSelector((state) => state.user?.isHost ?? false);

  const handleClick = () => {
    setCommentPostId(thisPostId);
    handleCommentOpen(thisPostId);
  };
  const handleEditClick = () => {
    setIsEditingThisComment(true);
    handleSetEditing(true);
    handleCommentOpen(thisPostId);
  };

  const handleDelete = () => {
    store.dispatch(deletePost(thisPostId));
  };

  // normalize guest data
  let when = (guest && guest.rsvp_when) || (post && post.comment_when) || '';
  if (when) when = when.slice(0, -5);

  const comment = guest.rsvp_comment || guest.comment || '';
  const guestName = guest.guest_name || guest.guestName || '';

  const viewDate = (post && post.viewDate) || guest.date_viewed || '';

  const canUserEdit = guest.comment && guest.userId === currentUserId; // RSVP comments can't be edited here

  const scrollToHash = (locationHash) => {
    const target = document.querySelector(locationHash);
    if (target && !locationHash.includes('module')) {
      smoothScroll(target, 227);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    const locationHash = window.location.hash;
    if (locationHash) {
      scrollToHash();
    }
  }, []);

  return (
    <div className="wic__guest-post">
      <div className="wic__guest-post-details">
        <Typography
          variant="paragraph3"
          classNames="wic__guest-name"
          data-qa-id="guest-name"
          data-qa-value={guestName}
        >
          {guestName}
        </Typography>
        {!isReply && label !== 'no' && label !== 'no_reply' && (
          <>
            <span>|</span>
            <AttendeeCopy label={label} guest={guest} dataQaId="rsvp-guest-count" />
          </>
        )}
      </div>
      {label === 'no_reply'
        ? <LastViewedCopy viewDate={viewDate} showViewDate={isHost} />
        : <>
            {comment && (
              <Typography variant="paragraph3" data-qa-id="guest-rsvp-comment">
                {comment}
              </Typography>
            )}
            <div className="wic__guest-post-ctas">
              {!isEditingThisComment && (
                <>
                  {when && <TimeSince timestamp={when} />}
                  {thisPostId && currentUserId && hasRsvpd && (
                    <>
                      {when && <span>|</span>}
                      <LikeButton
                        userId={currentUserId}
                        postId={thisPostId}
                        post={post}
                        dataQaId="guest-comment-like"
                      />
                      <span>|</span>
                      {!isReply && (
                        <CommentButton
                          userId={currentUserId}
                          post={post}
                          handleCommentClick={handleClick}
                          dataQaId="guest-reply-icon"
                        />
                      )}
                    </>
                  )}
                  {canUserEdit && !isParentPost && (
                    <>
                      <span>|</span>
                      <button
                        type="button"
                        onClick={handleEditClick}
                        className="unstyled-button link small"
                        data-qa-id="guest-comment-edit"
                      >
                        Edit
                      </button>
                      <span>|</span>
                      <button
                        type="button"
                        onClick={handleDelete}
                        className="unstyled-button link small"
                        data-qa-id="guest-comment-delete"
                      >
                        Delete
                      </button>
                    </>
                  )}
                </>
              )}
            </div>
          </>}
    </div>
  );
};
